import { useRouter } from "next/navigation";
import React from "react";
import { DiagItemCard } from "@aph/ui-lib-humanx";
import IconLeft from "$/icons/icon-left.svg";
import IconRight from "$/icons/icon-right.svg";
import Slider, { Slide } from "@/components/Slider";
import { DeviceInfo } from "@/interface/deviceInfo";
import { DiagnosticDetailInterface } from "@/redux/slice/diagnostics/types/fetchDiagnosticsPayload";
import { NEXT_PUBLIC_PATIENT_BASE_URL } from "@/libs/constants/auth";
import styles from "./DiagnosticCardsList.module.scss";

interface DiagnosticCardsListInterface {
  diagnostics: DiagnosticDetailInterface[];
  userAgent: DeviceInfo;
  viewAllUrl?: string;
  utm_medium?: string;
}

function DiagnosticCardsList(props: DiagnosticCardsListInterface) {
  const { diagnostics, userAgent, viewAllUrl, utm_medium } = props;
  const router = useRouter();

  return (
    <>
      {diagnostics?.length > 0 ? (
        <div className={styles.slidercontainer}>
          <Slider
            dotsWrapperClass={styles.dotsWrapperClass}
            dotClass={styles.dotClass}
            slidesToShow={userAgent?.isDesktop ? 4 : 1}
            dotClassActive={styles.dotClassActive}
            center={!userAgent?.isDesktop}
            showDots={true}
            columnGap={20}
            autoplay={false}
            showArrows={userAgent?.isDesktop}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
          >
            {diagnostics.map((diagnostic: DiagnosticDetailInterface, index) => {
              const diagnosticProfileUrl = `${NEXT_PUBLIC_PATIENT_BASE_URL}/lab-tests/${diagnostic?.canonicalTag}?utm_source=momverse${utm_medium ? `&utm_medium=${utm_medium}` : ""}`;

              return (
                <React.Fragment key={`card-${diagnostic?.id}`}>
                  <Slide key={diagnostic?.id} index={index} className={styles.diagnosticCardSlide}>
                    <a href={diagnosticProfileUrl} onClick={(e) => e.preventDefault()}>
                      <DiagItemCard
                        icon={diagnostic?.imageUrl}
                        itemTitle={diagnostic?.itemName}
                        inclusionText={diagnostic?.itemInclusionText}
                        tags={diagnostic?.itemTags}
                        price={
                          diagnostic?.diagnosticPricing?.length > 0
                            ? diagnostic?.diagnosticPricing?.[0]?.price?.toString()
                            : null
                        }
                        slashedPrice={
                          diagnostic?.diagnosticPricing?.length > 0 &&
                          diagnostic?.diagnosticPricing?.[0]?.showSlashedPrice
                            ? diagnostic?.diagnosticPricing?.[0].mrp?.toString()
                            : null
                        }
                        discountPercentText={
                          diagnostic?.diagnosticPricing?.length > 0 &&
                          diagnostic?.diagnosticPricing[0]?.showDiscountPercent
                            ? `${diagnostic?.diagnosticPricing[0]?.nonCircleDiscPercent} % off`
                            : null
                        }
                        onClick={() => router.push(diagnosticProfileUrl)}
                        onCTAClick={() => router.push(diagnosticProfileUrl)}
                        CTAtext="Book Now"
                        isMomNBaby={true}
                        className={styles.diagnosticCard}
                      />
                    </a>
                  </Slide>
                </React.Fragment>
              );
            })}
          </Slider>
        </div>
      ) : null}
    </>
  );
}

export default DiagnosticCardsList;
